module.exports = __webpack_public_path__ + "static/media/traffic-light.826ab718.svg";